module.exports = __webpack_public_path__ + "static/fipcwhiteteddy-cb22b9ca2ef0dcd0772a1a78bc0dae0d.jpeg";